<template>
  <NoteSection
    label="Reason for Visit"
    required
    :highlight-required="isSectionIncomplete"
    :form-validated="formValidated"
  >
    <text-area
      v-model="visit_reason"
      class="col-sm-9.5"
      label="Enter reason for visit..."
      required
      ai
      counter="7300"
      maxlength="7300"
      word-count="6"
      @click:prepend="generateReasonForVisit"
      @input="$emit('input', visit_reason)"
    ></text-area>
    <!-- <checkbox
      v-model="add_to_note"
      label="Add to note"
      class="col-sm-2.5 align-self-center"
      @input="$emit('update:add-to-note', add_to_note)"
    ></checkbox> -->
  </NoteSection>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },

    // addToNote: {
    //   type: Boolean,
    //   default: false,
    // },
    woundList: {
      type: Array,
      default: null,
    },
    treatmentStatus: {
      type: Boolean,
      default: false,
    },
    formValidated: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visit_reason: this.value,

      // add_to_note: this.addToNote,
    }
  },
  computed: {
    // Evaluates if the visit reason text is missing or blank
    isSectionIncomplete() {
      return !this.visit_reason || !this.visit_reason.trim()
    },
  },
  watch: {},
  methods: {
    generateReasonForVisit() {
      try {
        if (!this.treatmentStatus) {
          this.$root.confirm({
            titleIconColor: 'error',
            title: 'Treatments not validated!',
            body: 'You must have at least one treatment for this encounter and all encounter treatments must be validated before generating automatic text.',
            cancel: false,
          })

          return
        }

        let visitReason = ''
        const introText = [
          'I was asked to see this patient for my opinion on how to manage their',
          'To manage the patient\'s',
          'Management of',
          'Consultation and evaluation of',
          'Consultation for',
          'Evaluation of',
          'To evaluate',
          'To evaluate this patient for',
          'I am here to manage',
        ]

        const woundItems = []
        const dermItems = []
        const gTubeItems = []

        if (this.$custom.isEmpty(this.woundList)) {
          this.displayMsg('Can\'t generate Reason for Visit because the Wound list is empty', 'error')

          return
        }

        this.woundList.forEach(wound => {
          if (wound.practice_type_id === 1) {
            woundItems.push(wound)
          } else if (wound.practice_type_id === 5) {
            gTubeItems.push(wound)
          } else if (wound.practice_type_id === 6) {
            dermItems.push(wound)
          }
        })

        const woundLocations = woundItems.map(w => w.location.location_text)
        const dermLocations = dermItems.map(d => d.location.location_text)

        const hasWound = woundItems.length > 0
        const hasDerm = dermItems.length > 0
        const hasGTube = gTubeItems.length > 0

        if (!hasWound && !hasDerm && !hasGTube) {
          this.displayMsg('Can\'t generate Reason for Visit because the Wound list is empty', 'error')

          return
        }

        visitReason += this.$custom.randomString(introText)

        let reasonParts = []

        if (hasWound) {
          const woundLocationsText = this.$custom.toListCommaAnd(woundLocations, null, 'lc')
          let woundText = woundItems.length > 1 ? 'wounds' : 'a wound'
          woundText += ` ${this.$custom.randomString(['located', 'found'])}`
          woundText += ` ${this.$custom.randomString(['at the', 'on the'])} `
          woundText += woundLocationsText
          reasonParts.push(woundText)
        }

        if (hasDerm) {
          const dermLocationsText = this.$custom.toListCommaAnd(dermLocations, null, 'lc')
          let dermText = dermItems.length > 1 ? 'skin lesions' : 'a skin lesion'
          dermText += ` ${this.$custom.randomString(['located', 'found'])}`
          dermText += ` ${this.$custom.randomString(['at', 'on'])} the `
          dermText += dermLocationsText
          reasonParts.push(dermText)
        }

        if (hasGTube) {
          const gTubeReasons = new Set()

          gTubeItems.forEach((gTubeItem) => {
            let gTubeText
            if (gTubeItem.treatment.procedure_id === 150) {
              gTubeText = 'G-tube-related issues'
            } else if ([300, 301].includes(gTubeItem.treatment.procedure_id)) {
              gTubeText = 'emergent replacement of a gastrostomy tube'
            } else if ([311, 312, 321, 322, 331, 332].includes(gTubeItem.treatment.procedure_id)) {
              gTubeText = 'replacement of a gastrostomy tube'
            } else {
              gTubeText = 'G-tube-related issues'
            }
            gTubeReasons.add(gTubeText)
          })

          // Add unique G-tube reasons to the reasonParts
          reasonParts.push(...Array.from(gTubeReasons))
        }

        // Join all parts with commas and 'and'
        if (reasonParts.length === 1) {
          visitReason += reasonParts[0]
        } else if (reasonParts.length === 2) {
          visitReason += reasonParts.join(' and ')
        } else if (reasonParts.length > 2) {
          visitReason += reasonParts.slice(0, -1).join(', ') + ', and ' + reasonParts[reasonParts.length - 1]
        }

        visitReason += '.  '

        this.visit_reason = this.$custom.clean(visitReason, 'Visit Reason')
        this.$emit('input', this.visit_reason)
      } catch (error) {
        console.error('Error generating Visit Reason:', error)
        this.displayMsg(`There was an error trying to generate the Reason for Visit. Please try again. \n${error}`, 'error')
      }
    },
    displayMsg(msg, color) {
      this.$store.dispatch('notify', {
        value: msg, color: color,
      })
    },
  },
}
</script>
